import { useState, useEffect } from "react";
import { fetchTiposIdentificacion } from "../../services/parameter.service";

const useTiposIdentificacion = () => {
  const [tiposIdentificacion, setTiposIdentificacion] = useState([]);

  const getTiposIdentificacion = async () => {
    try {
      const response = await fetchTiposIdentificacion();
      setTiposIdentificacion(response.data.list);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTiposIdentificacion();
  }, []);

  return { tiposIdentificacion };
};

export default useTiposIdentificacion;
